import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import SmallLabel from 'base/components/SmallLabel';
import LargeLabel from 'base/components/LargeLabel';
import Teaser from 'base/components/Teaser';
import Date from 'base/components/Date';
import { ArrowForwardIcon, DomainIcon, LanguageIcon } from 'base/components/Icon';

const Abstract = styled.p`
  margin: 0.5rem 0 0 0;
  font-size: ${theme.fontSizes.default};
`;


const handleClick = (item) => {
  // open link in new window, but set opener to null first for security reasons
  // equivalent to rel="noopener" on a tags
  const w = window.open();
  w.opener = null;
  w.location = item.url;
};

const getLanguageLabel = (language) => {
  switch (language) {
    case 'English':
      return 'EN';
    case 'German':
      return 'DE';
    case 'French':
      return 'FR';
    case 'Italian':
      return 'IT';
    default:
      return language;
  }
};

const NewsList = ({ news }) => (
  <>
    {news && news.map((item) => (
      <Teaser
        key={item.id}
        item={item}
        actions={
          item.url && item.url.trim()
            ? [{
              icon: ArrowForwardIcon,
              onClick: handleClick,
              key: 'primary',
            }]
            : []
        }
      >
        <Teaser.MainCol>
          {item.topics && item.topics.map((topic) => (
            <SmallLabel key={topic.topic} style={{ color: theme.colors.darker }}>
              {topic.topic}
            </SmallLabel>
          ))}
          <LargeLabel style={{ marginTop: '0.2rem' }} isPrimary>{item.title}</LargeLabel>
          <Abstract>{item.abstract}</Abstract>

          <Teaser.MetaWrapper>
            <Teaser.Meta>
              <Date date={item.date} />
            </Teaser.Meta>
            <Teaser.Meta>
              <SmallLabel>
                <DomainIcon />
&nbsp;
                {item.publisher}
              </SmallLabel>
            </Teaser.Meta>
            <Teaser.Meta>
              <SmallLabel>
                <LanguageIcon />
                {getLanguageLabel(item.language)}
              </SmallLabel>
            </Teaser.Meta>
          </Teaser.MetaWrapper>

        </Teaser.MainCol>
      </Teaser>
    ))}
  </>
);

NewsList.propTypes = {
  news: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default NewsList;
